import { addDoc, arrayRemove, arrayUnion, collection, deleteDoc, doc, onSnapshot, query, serverTimestamp, updateDoc } from "firebase/firestore";
import { auth, db } from "../config/firebase";


export const QueryPosts = (isAdmin, setPosts) => {
    try {
        const q = query(collection(db, "posts"))
        return onSnapshot(q, querySnapshot => {
            if (!querySnapshot.empty) {
                let d = {}
                querySnapshot.forEach((doc) => {
                    const { title, content, admin, ack, timestamp, flight } = doc.data()
                    if (timestamp) {
                        let a = { 
                            title, content, admin, ack, flight,
                            ms : timestamp.seconds * 1000,
                            date : new Date(timestamp.seconds * 1000).toLocaleString('th'),
                            isRead : isAdmin ? null : [...doc.data().ack].includes(auth.currentUser.uid)
                        }
                        d = {...d, [doc.id] : {...a}}
                    }
                    
                });
                setPosts({...d})
            }
        })
    }
    catch (e) {
        console.log(e)
    }
}

export const AddPost = async (data) => {
    try {
        await addDoc(collection(db, 'posts'), {...data, ack : [], flight : parseInt(data.flight), timestamp : serverTimestamp()})
    }
    catch (e) {
        console.log(e)
        alert('เกิดข้อผิดพลาด')
    }
}

export const DeletePost = async (postID) => {
    try {
        await deleteDoc(doc(db, 'posts', postID))
    }
    catch (e) {
        console.log(e)
    }
}

export const UpdateAck = async (isChecked, postID) => {
    try {
        const docRef = doc(db, "posts", postID);
        await updateDoc(docRef, {
            ack : isChecked ? arrayUnion(auth.currentUser.uid) : arrayRemove(auth.currentUser.uid)
        });
    }
    catch (e) {
        console.log(e)
    }
}